export default {
    actions: {
        save: 'Uložit',
        saveChanges: 'Uložit změny',
        cancel: 'Zrušit',
        delete: 'Smazat',
        close: 'Zavřít',
        open: 'Otevřít',
        search: 'Hledat',
        apply: 'Použít',
        clear: 'Vymazat',
        edit: 'Upravit',
        create: 'Vytvořit',
        new: 'Nový',
        confirm: 'Potvrdit',
        back: 'Zpět',
        next: 'Další',
        previous: 'Předchozí',
        export: 'Exportovat',
        import: 'Importovat'
    },
    validation: {
        required: 'Povinné pole',
        email: 'Neplatný e-mail',
        min: 'Minimálně {n} znaků',
        max: 'Maximálně {n} znaků'
    },
    confirm: {
        title: 'Opravdu pokračovat?',
        irreversible: 'Tato akce je nevratná.'
    },
    pagination: {
        prev: 'Předchozí',
        next: 'Další',
        rangeOf: '{from}–{to} z {total}',
        range: '{from}–{to}',
        page: 'Strana {n}',
        perPage: 'na stránku'
    },
    errors: {
        generic: 'Neznámá chyba',
        network: 'Bez připojení',
        unauthorized: 'Nepřihlášený přístup',
        forbidden: 'Nemáte oprávnění',
        notFound: 'Nenalezeno',
        server: 'Chyba serveru'
    },
    common: {
        loading: 'Načítání…',
        empty: 'Nic nenalezeno',
        yes: 'Ano',
        no: 'Ne'
    },
    theme: {
        label: 'Vzhled',
        light: 'Světlý',
        auto: 'Auto',
        dark: 'Tmavý'
    },
    nav: {
        openMenu: 'Otevřít menu',
        closeMenu: 'Zavřít menu',
        collapseSidebar: 'Skrýt navigaci',
        expandSidebar: 'Zobrazit navigaci'
    },
    selectedSingular: 'vybrán',
    selectedPlural: 'vybráno'
}
